import { ENTITY_NAME } from '@esentai/core/features/parkingWhitelistFilter/consts';

export const CREATE_PARKING_WHITELIST_GROUP = `${ENTITY_NAME}/CREATE`;
